import { defineComponent } from "bitecs";

export const TagTouchedComponent = defineComponent({});
